import { ReportGroup } from '@/api/generatedApi';
import { Box, Typography } from '@mui/material';
import { useDeleteReportGroup } from '@/hooks/api/reports/useDeleteReportGroup';
import { DeleteModal } from './DeleteModal';
import { AssetThumbnailGrid } from '@/components/AssetThumbnailGrid/AssetThumbnailGrid';

export const DeleteGroupModal = ({
  open,
  onClose,
  onSuccess,
  group,
  groupName,
  reportId,
}: {
  open: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  group: ReportGroup;
  groupName: string;
  reportId: string;
}) => {
  return (
    <DeleteModal
      title='Delete Group'
      isOpen={open}
      onClose={onClose}
      onConfirm={onSuccess}
      useHook={useDeleteReportGroup}
      hookParams={{ reportId, groupId: group.id }}
      itemName={groupName}
      item={group}
    >
      <Box
        sx={{
          p: 2,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: '6px',
          backgroundColor: 'action.hover',
          mb: 2,
        }}
      >
        <Typography variant='subtitle2' sx={{ mb: 1, fontWeight: 600 }}>
          {groupName}
        </Typography>
        <AssetThumbnailGrid assetIds={group.assetIds} tenantId={group.tenantId} />
      </Box>
    </DeleteModal>
  );
};
